module.exports = __webpack_public_path__ + "img/community.2da57ec4.png";